module.exports = __webpack_public_path__ + "b3382c7fc5b0af1d0e2c6d588a83d650.pdf";